import {
	GET_PRODUCT,
	GET_PRODUCT_ERROR,
	CHANGE_PRICE,
	CLEAR_PRODUCT,
	GET_ALERTS,
	GET_ALERTS_ERROR,
	SAVE_ALERTS,
} from "../actions/types";

const initialState = {
	product: null,
	loading: true,
	// { mails: { <alert>: { enabled, to } }, paperLow, rearTrayLow, updatedAt,
	// updatedBy } as saved, or null until loaded
	alerts: null,
	// { _id, name, email } of every admin, to add to a mail
	admins: [],
	alertsLoading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GET_PRODUCT:
			return {
				...state,
				loading: false,
				product: payload,
			};
		case CHANGE_PRICE:
			return {
				...state,
				// A row that was not there is a photo row, added by its first price
				product: state.product.some((item) => item._id === payload._id)
					? state.product.map((item) =>
							item._id === payload._id ? { ...item, price: payload.price } : item,
						)
					: [...state.product, payload],
			};
		case GET_PRODUCT_ERROR:
			return {
				...state,
				loading: false,
			};
		case GET_ALERTS: {
			const { admins, ...alerts } = payload;
			return {
				...state,
				alertsLoading: false,
				alerts,
				admins: admins || [],
			};
		}
		case SAVE_ALERTS:
			return {
				...state,
				alerts: payload,
			};
		case GET_ALERTS_ERROR:
			return {
				...state,
				alertsLoading: false,
			};
		case CLEAR_PRODUCT:
			return initialState;
		default:
			return state;
	}
}
